import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MenuStateService } from 'src/app/services/menu-state.service';
import { Subscription } from 'rxjs';
import { ApiService } from '@app/services/api.service';
import { WarningModalConfig } from '@app/shared/warning-modal/warning-modal.component';
import { EncryptionService } from '@app/services/encryption.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
  selectedMenu: string;
  selectedSubMenu: string;
  urlDict: { [key: string]: string };
  currentUser: User;
  private menuStateSub: Subscription;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private menuStateService: MenuStateService,
    private apiService: ApiService,
    private encryptionService: EncryptionService
  ) {
    this.authenticationService.currentUser.subscribe(
      (x) => (this.currentUser = x)
    );
    const urls = this.router.url.split('/');
    this.selectedMenu =
      urls[1] == 'campaign-management' ? 'campaigns' : urls[1];
    if (urls.length > 2) {
      this.selectedSubMenu =
        this.selectedMenu === 'campaigns'
          ? urls[2] == 'list'
            ? 'campaigns'
            : 'content'
          : urls[2];
    }
  }

  aiAssistants: any[] = [];
  showWarningModal = false;
  warningModalConfig: WarningModalConfig = {
    title: 'Create AI Assistant',
    message: '',
    icon: 'info'
  };
  showAssistantChoice = false;

  ngOnInit() {
    this.menuStateSub = this.menuStateService.selectedMenu.subscribe(menu => {
      this.selectedMenu = menu;
    });
  }

  ngOnDestroy() {
    if (this.menuStateSub) this.menuStateSub.unsubscribe();
  }

  onMenuClick(menu: string, subMenu: string) {
    if (this.selectedMenu != menu) {
      this.selectedMenu = menu;
    } else {
      this.selectedMenu = null;
    }
    if (subMenu != null) {
      this.selectedSubMenu = subMenu;
    }
  }

  checkAssistant() {
    this.apiService.getAgentAssistant().subscribe(
      (res) => {
        this.aiAssistants = res['assistants'];
        if (this.aiAssistants.length == 0) {
          this.showSubscriptionWarning();
        } else if (this.aiAssistants.length == 1) {
          this.onAssistantSelect(this.aiAssistants[0].id);
        } else {
          this.showChoicePopup();
        }
      },
      (err) => { }
    );
  }

  onAssistantSelect(id: any) {
    const selectedId = this.encryptionService.encrypt(id.toString());
    this.apiService.generateAgentSession(selectedId).subscribe(
      (res: any) => {
        if (res?.chatUrl) {
          window.open(res.chatUrl, '_blank');
        }
      },
      (err) => {
      }
    );
  }

  onAssistantChoiceSelect(id: any) {
    this.showAssistantChoice = false;
    this.onAssistantSelect(id);
  }
  showChoicePopup(){
    this.warningModalConfig = {
      title: 'Select an AI Assistant',
      message: '',
      icon: 'info',
      radioMode: true,
      radioOptions: this.aiAssistants.map(item => ({
        id: item.id,
        label: item.firstName + ' ' + item.lastName,
        subLabel: item.channelDetails?.email
      })),
      onRadioSelect: (id: any) => this.onAssistantSelect(id)
    };
    this.showWarningModal = true;
    this.showAssistantChoice = false;
  }
  showSubscriptionWarning() {
    this.warningModalConfig = {
      message: 'Create an AI Assistant to proceed with AI Agent',
      icon: 'warning',
      showDetails: false,
      details: [],
      secondaryButton: {
        text: 'Close',
        action: 'close'
      }
    };
    this.warningModalConfig.primaryButton = {
      text: 'Create AI Assistant',
      action: 'create',
      icon: 'M12 2L2 7L12 12L22 7L12 2ZM2 17L12 22L22 17ZM2 12L12 17L22 12'
    };
    this.showWarningModal = true;
  }

  onWarningModalClose() {
    this.showWarningModal = false;
  }

  onWarningModalAction(action: string) {
    this.router.navigate(['settings/ai']);
    this.onMenuClick('settings', 'ai');
    this.showWarningModal = false;
  }
}
